import Vue from 'vue';
import store from './store';
import axios from "./modules/axios";

import "@/assets/style/style.scss";

import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();

// might as well get the cart data fresh
store.dispatch('cart/getData');

window.scrollToPosition = function(position) {
  const header = document.querySelector('[data-puori-header]');
  const headerHeight = header ? header.offsetHeight : 0;
  window.scrollTo({
    top: position - headerHeight,
    behavior: 'smooth'
  });
}

Vue.prototype.$eventBus = new Vue();
Vue.prototype.$formatMoney = Shopify.formatMoney.bind(Shopify);

class OSP {
  constructor(root) {
    this.root = root;
    this.rootClickHandler = this.rootClickHandler.bind(this);
    this.handlePopState = this.handlePopState.bind(this);
    this.shouldRunInitializer = 'ospRunInitializer' in root.dataset;
    root.addEventListener('click', this.rootClickHandler);
    window.addEventListener('popstate', this.handlePopState);
    history.replaceState({ osp: location.href }, location.href);
  }

  handlePopState() {
    if (history.state && history.state.osp) {
      this.load(history.state.osp, false);
    }
  }

  rootClickHandler(evt) {
    if (!evt.target) return;
    if (evt.target.hasAttribute('data-osp-link')) {
      evt.preventDefault();
      const href = evt.target.href;
      this.load(href);
    }
  }

  toggleLoadingClass(root, add) {
    [...root.querySelectorAll('[data-osp-loading-class]')].forEach(element => {
      const className = element.dataset.ospLoadingClass;
      element.classList.toggle(className, add);
    });
  }

  saveState() {
    this.state = {};
    [...document.querySelectorAll('[data-osp-state]')].forEach(el => {
      const [key, attributesString] = el.dataset.ospState.split(':');
      const attributes = attributesString.split(',').map(s => s.trim());
      this.state[key] = attributes.reduce((acc, attr) => {
        return {
          ...acc,
          [attr]: el[attr]
        };
      }, {});
    });
  }

  hydrateState() {
    if (!this.state) return;
    [...document.querySelectorAll('[data-osp-state]')].forEach(el => {
      const [key, attributesString] = el.dataset.ospState.split(':');
      const attributes = attributesString.split(',').map(s => s.trim());
      attributes.forEach(attr => {
        el[attr] = this.state[key][attr];
      });
    });
  }

  async load(url, withState = true) {
    this.toggleLoadingClass(this.root, true);
    this.saveState();
    const { data } = await axios.get(url);
    const tmp = document.createElement('div');
    tmp.innerHTML = data;
    const tmpRoot = tmp.querySelector('[data-osp]');
    this.toggleLoadingClass(tmpRoot, true);
    if (!tmpRoot) return;
    if (withState) {
      history.pushState({ osp: url }, '', url);
    }
    OSP.destructorQueue.map(destructor => destructor());
    OSP.destructorQueue = [];
    this.root.innerHTML = tmpRoot.innerHTML;
    this.hydrateState();
    initialize(this.root);
    requestAnimationFrame(() => {
      this.toggleLoadingClass(this.root, false);
    });
  }
}

const osps = document.querySelectorAll('[data-osp]');
[...osps].forEach(osp => new OSP(osp));

const squares = document.querySelectorAll('[data-square]');
[...squares].forEach(squareEl => {
  const size = squareEl.dataset.square;

  switch (size) {
    case 'small':
    default:
      const path = squareEl.querySelector('.square-path');
      const scale = '1.5';
      const rotation = Math.random() * 360 - 180;
      const tx = Math.random() * -60
      const ty = Math.random() * -50;
      path.style.transform = `scale(${scale}) rotate(${rotation}deg) translate(${tx}%, ${ty}%)`;
  }
});

OSP.destructorQueue = [];

window.OSP = OSP;

const req = require.context('./components/', true, /\.vue$/);
const components = req.keys().reduce((components, path) => {
  const m = req(path);
  if (m.default && m.default.selector) {
    return [...components, m.default];
  }
  return components;
}, []);

Vue.prototype.$http = axios;

Vue.prototype.$translations = window.ShopifyTranslations;

function initialize(target) {
  components.forEach(component => {
    const elements = Array.prototype.slice.call(target.querySelectorAll(component.selector));

    elements.forEach(el => new Vue({
      ...component,
      el,
      // takes data attributes (data-*) on the root element and parses them as props
      propsData: Object.entries(el.dataset).reduce((sum, [key, val]) => ({
        ...sum,
        get [key]() {
        try {
          return JSON.parse(val);
        } catch(err) {
          return val;
        }
        }
      }), {})
    }));
  });
}

window.shopifyThemeInitialize = initialize;

initialize(document);

if (window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', ({ target }) => initialize(target));
}


// fix floating labels in ie
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if (isIE11) {
  const flInputs = Array.prototype.slice.call(document.querySelectorAll('.floating-label-input'));
  flInputs.forEach(fli => {
    const input = fli.querySelector('input');
    input.addEventListener('focus', () => {
      fli.classList.add('filled');
    });

    input.addEventListener('blur', () => {
      if (!input.value) {
        fli.classList.remove('filled');
      }
    })
  });
}
